export const params = {
  title: 'IT-era',
  description: `IT-era : architecte web.`
};
